<template>
	<ac-modal :title="'Member Reminder Activity History'" ref="modal" :sizeClass="'modal-dialog'">
		<template>
			<h5>Please see below details related to reminder that have been sent to your members below.
				Please note: only the three most recent will appear here.</h5>
			<table class="mdl-data-table table table-responsive dataTable no-footer dtr-inline" style="table-layout: fixed; width: 100%;">
				<thead>
				<tr>
					<th width="20%">Date Sent</th>
					<th width="30%">Sent By</th>
					<th width="50%">Email</th>
				</tr>
				</thead>
				<tbody v-if="reminders.length>0">
				<tr v-for="reminder in reminders">
					<td>{{ reminder.sentDate | shortDate }}</td>
					<td>{{ reminder.name }}</td>
					<td>{{ reminder.emailAddress }}</td>
				</tr>
				</tbody>
				<tbody class="text-center" v-if="reminders.length===0">
				<tr>
					<td colspan="3">No reminders have been sent yet.</td>
				</tr>
				</tbody>
			</table>
		</template>
	</ac-modal>
</template>

<script>
	import {api} from "../../../../global/framework/api.js";

	export default {
		name: "RemindersModal",
		data() {
			return {reminders: []};
		},
		methods: {
			async showModal(providerEntityId) {
				let result = await api.get('ProviderEntity', providerEntityId, 'GetLatestReminders');
				//console.log(result);
				this.reminders = result;
				this.$refs.modal.open();
			}
		}

	}
</script>

<style scoped>

</style>